import styled from 'styled-components';


export const Div = styled.div`
    width:1px;
    height: 1px;
`